import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { DeliveryAddressInput, DeliveryAddressItem } from '@tiles-erp/shared-types';
import { apiFetch } from '../../lib/api-client';

const KEY = 'delivery-addresses';

export function useDeliveryAddresses(branchId?: string, includeInactive = false) {
  const params = new URLSearchParams();
  if (branchId) params.set('branchId', branchId);
  if (includeInactive) params.set('includeInactive', 'true');
  return useQuery({ queryKey: [KEY, branchId ?? null, includeInactive], queryFn: () => apiFetch<DeliveryAddressItem[]>(`/delivery-addresses?${params}`) });
}

export function useSaveDeliveryAddress() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...input }: DeliveryAddressInput & { id?: string }) => apiFetch<DeliveryAddressItem>(id ? `/delivery-addresses/${id}` : '/delivery-addresses', { method: id ? 'PATCH' : 'POST', body: JSON.stringify(input) }),
    onSuccess: () => client.invalidateQueries({ queryKey: [KEY] }),
  });
}

export function useDeleteDeliveryAddress() {
  const client = useQueryClient();
  return useMutation({ mutationFn: (id: string) => apiFetch(`/delivery-addresses/${id}`, { method: 'DELETE' }), onSuccess: () => client.invalidateQueries({ queryKey: [KEY] }) });
}
